import { ReduxState } from "../store";

export const selectEmail = (state: ReduxState) => state.signUp.email;
export const selectUserId = (state: ReduxState) => state.signUp.userId;
export const selectEditMode = (state: ReduxState) => state.signUp.editMode;
export const selectLogoImage = (state: ReduxState) => state.signUp.logoImage;
export const selectSignUpStep = (state: ReduxState) => state.signUp.signUpStep;
export const selectLegalModal = (state: ReduxState) => state.signUp.legalModal;
export const selectFetchStatus = (state: ReduxState) => state.signUp.fetchStatus;
export const selectPhoneNumber = (state: ReduxState) => state.signUp.phoneNumber;
export const selectEmployerInfo = (state: ReduxState) => state.signUp.employerInfo;
export const selectLegalAgreement = (state: ReduxState) => state.signUp.legalAgreement;
export const selectDisablePhoneNumber = (state: ReduxState) => state.signUp.disablePhoneNumber;
export const selectPersonalEmailWarningModal = (state: ReduxState) => state.signUp.personalEmailWarningModal;
export const selectSignUpMode = (state: ReduxState) => state.signUp.signUpMode;
